import { render, staticRenderFns } from "./IntegrationsMail.vue?vue&type=template&id=edbdc208&scoped=true&"
import script from "./IntegrationsMail.vue?vue&type=script&lang=js&"
export * from "./IntegrationsMail.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsMail.vue?vue&type=style&index=0&id=edbdc208&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbdc208",
  null
  
)

export default component.exports